import script from "./form-generation.vue?vue&type=script&setup=true&lang=ts"
export * from "./form-generation.vue?vue&type=script&setup=true&lang=ts"

import "./form-generation.vue?vue&type=style&index=0&id=fb4f204a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fb4f204a"]])

export default __exports__